import { APIService } from "../../../../network/api/APIService";

export const UserAccess = (formData) => {

  return APIService({
    endpoint: "/account/access/",
    method: "PUT",
    credentials: "include",
    data: formData
  });
};